module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "bm-title"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is dedicated to my children. May you have lasting inner peace from a young age and the determination to strive towards greatness in all aspects of your life. To my husband, thank you for your love and support. To all my family, thank you for everything! I know I’ve been able to write this book because of all of the people that have come into and out of my life and I am thankful for those people. To my best friend, Caroline Hatty, for always being positive and showing me what a true friend is. To all the mentors in my life, thank you for your time and guidance. Most importantly, I thank God for having allowed all the “negative” things into my life as lessons to learn from. God has given each of us a powerful mind along with the wonderful gift of choice and I am very thankful for that. This book is also dedicated to anyone who has ever struggled to find inner peace, true happiness, and satisfaction in life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A special thank you to my editor, Guitta Karubian, your guidance during this process was life changing!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A very special thank you to Haleigh Vanderstelt for designing the book cover and helping create the images provided throughout the book. You can contact Haleigh for design work at: "), _c('a', {
    attrs: {
      "href": "http://www.HaleighVanderstelt.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HaleighVanderstelt.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c3c9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0